import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import FooterPage from "../components/Footer";

export default function Impressum() {
  const { t } = useTranslation();

  return (
    <>
      <section className="relative flex items-center justify-center w-full min-h-screen overflow-hidden bg-white">
        <motion.div
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="absolute top-0 left-0 z-50 w-full"
        >
          <Navbar />
        </motion.div>

        <div className="max-w-2xl mx-auto px-6 py-12 mt-[104px]">
          <h1 className="text-2xl font-semibold text-gray-900 mb-6">
            {t("impressum.title")}
          </h1>

          <p className="text-black mb-4">
            <span className="font-bold">{t("impressum.providerTitle")}</span>
          </p>

          <p className="text-black mb-4">
            <span className="font-bold">{t("impressum.provider")}</span>{" "}
            Snow Dream Studios GmbH Schärenmoosstrasse 77 8052 Zürich{" "}
            {t("impressum.switzerland")}
          </p>

          <p className="text-black mb-4">
            <span className="font-bold">{t("impressum.contact")}</span>{" "}
            {t("impressum.email")}:{" "}
            <a href="mailto:info@swisstaxfile.ch" className="underline text-black hover:text-gray-600">
              info@swisstaxfile.ch
            </a>{" "}
            {t("impressum.website")}:{" "}
            <a href="https://www.swisstaxfile.ch" className="underline text-black hover:text-gray-600" target="_blank" rel="noreferrer">
              www.swisstaxfile.ch
            </a>
          </p>

          <p className="text-black mb-4">
            <span className="font-bold">{t("impressum.legalNoticeTitle")}</span>{" "}
            {t("impressum.legalNoticeText")}
          </p>

          <p className="text-black mb-4">
            <span className="font-bold">{t("impressum.copyrightTitle")}</span>{" "}
            {t("impressum.copyrightText")}
          </p>

          {/* <p className="text-black mt-5 font-bold">
            {t("impressum.brandText")}
          </p> */}
        </div>
      </section>
      <FooterPage />
    </>
  );
}